angular
  .module("myApp")
  .controller(
    "PPManagerBoxController",
    function (
      Dialog,
      $scope,
      Notification,
      Codifiers,
      PpAssignExpert,
      PpUnassignExpert,
      PpSetKonsolidetajsExpert,
      PpSaveLzpMeta,
      PpAssignResponsible,
      PpUnassignResponsible,
      PpChangeRawStatus,
      EkspertizeCreate,
      EkspertizeFixup,
      EkspertizeRemove,
      $http
    ) {
      this.events = {
        "set-lzp-eksperts-1": "Piesaistīts 1. LZP eksperts",
        "set-lzp-eksperts-2": "Piesaistīts 2. LZP eksperts",
        "lzp-eksperts-1": "1. LZP eksperts darbojas",
        "lzp-eksperts-2": "2. LZP eksperts darbojas",
        "lzp-eksperts": "LZP konsolidācija",
        "eksperts-add": "Piesaistīts eksperts",
        "eksperts-remove": "Noņemts eksperts",
        "eksperts-set-konsolidetajs": "Iestatīts kā konsolidētājs",
        "eksperts-set-status": "Eksperts darbojas",
        "eksperts-status": "Eksperta konsolidācija",
        eksperts: "Eksperta konsolidācija",
      }

      this.assignResponsible = () => {
        this.assignResponsibleImpl("PIETEIKUMS")
      }

      this.assignRiskResponsible = () => {
        this.assignResponsibleImpl("RISKS")
      }

      this.assignResponsibleImpl = (veids) => {
        const opts = {}
        const p = {
          id: $scope.dto.id,
          _title: "Atbildīgās personas izvēle",
        }
        Dialog.dialog("pages/dialogs/assign-lzp-expert.form.html", p, opts, (p, action) => {
          if (action === "save") {
            return Dialog.finish(
              new PpAssignResponsible({
                veids,
                id: $scope.dto.id,
                adm_lietotajs_id: p.eksperts_id,
              }),
              $scope.reload
            )
          }
        })
      }

      this.removeEkspertize = (ekspertize) => {
        const dto = new EkspertizeRemove({
          id: ekspertize.pd_versija_id,
          ekspertize_id: ekspertize.id,
        })

        dto.$save(() => {
          Notification.success("Tukšā ekspertīze izdzēsta.")
          $scope.reload()
        }, $scope.failing)
      }

      this.ppChangeRawStatus = () => {
        const opts = {}
        const p = {
          id: $scope.dto.id,
          ir_jauna_versija: true,
          orig_statuss: $scope.dto.statuss,
          statuss: $scope.dto.statuss,
          _statusi: Codifiers.kla.statusi,
          _statuss: Codifiers.kla.statuss,
        }
        Dialog.dialog("pages/dialogs/pp-change-raw-status.form.html", p, opts, (p, action) => {
          if (action === "save") {
            return Dialog.finish(
              new PpChangeRawStatus({
                id: $scope.dto.id,
                statuss: p.statuss,
                ir_jauna_versija: p.ir_jauna_versija,
              }),
              $scope.reload
            )
          }
        })
      }

      this.assignExpert = (ekspertize) => {
        const opts = {}
        const p = {
          id: ekspertize.pd_versija_id,
          ekspertize_id: ekspertize.id,
        }
        const page = ekspertize.veids.startsWith("LZP")
          ? "pages/dialogs/assign-lzp-expert.form.html"
          : "pages/dialogs/assign-expert.form.html"
        Dialog.dialog(page, p, opts, (p, action) => {
          if (action === "save") {
            return Dialog.finish(new PpAssignExpert(p), $scope.reload)
          }
        })
      }

      this.setKonsolidetajsExpert = (ekspertize, e) => {
        const dto = new PpSetKonsolidetajsExpert({
          id: ekspertize.pd_versija_id,
          ekspertize_id: ekspertize.id,
          eksperts_id: e.eksperts_id,
        })
        dto.$save(() => {
          Notification.success("Konsolidētājs iestatīts.")
          $scope.reload()
        }, $scope.failing)
      }

      this.unassignResponsible = (a) => {
        if (!confirm(`Atsaistīt atbildīgo personu ${a.vards} ${a.uzvards}?`)) return

        const dto = new PpUnassignResponsible({
          id: $scope.dto.id,
          adm_lietotajs_id: a.adm_lietotajs_id,
          veids: a.veids,
        })
        dto.$save(() => {
          Notification.success("Atbildīgais atsaistīts.")
          $scope.reload()
        }, $scope.failing)
      }

      this.unassignExpert = (ekspertize, e) => {
        const dto = new PpUnassignExpert({
          id: ekspertize.pd_versija_id,
          ekspertize_id: ekspertize.id,
          eksperts_id: e.eksperts_id,
        })
        dto.$save(() => {
          Notification.success("Eksperts atsaistīts.")
          return $scope.reload()
        }, $scope.failing)
      }

      this.assignNumber = ($event) => {
        $event?.stopPropagation()

        $scope.is_number_loading = true
        $http({ method: "POST", url: "/data/pp_assign_auto_number", data: { id: $scope.dto.id } })
          .then((obj) => {
            $scope.is_number_loading = false
            Notification.success(`${obj?.data?.numurs}`)
            $scope.reload()
          })
          .catch(() => {
            $scope.is_number_loading = false
            $scope.failing
          })
      }

      const read_date = (d) => {
        if (!d) {
          return null
        }
        return moment(d).toDate()
      }
      const write_date = (d) => {
        if (d) {
          return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
        }
        return null
      }

      this.editLzpMeta = () => {
        const opts = {}
        const p = {
          id: $scope.dto.id,
          nosaukums_en: $scope.dto.nosaukums_en,
          numurs: $scope.dto.numurs,
          pieteikumu_karta_id: $scope.dto.pieteikumu_karta_id,
          ris_3_kods: $scope.dto.ris_3_kods,
          sakuma_gads: $scope.dto.sakuma_gads,
          projekta_vaditaja_vards: $scope.dto.projekta_vaditaja_vards,
          projekta_vaditaja_uzvards: $scope.dto.projekta_vaditaja_uzvards,
          lzp_pecdoktorants: $scope.dto.lzp_pecdoktorants,
          pecdoktorants_vards_uzvards: $scope.dto.pecdoktorants_vards_uzvards,
          sakuma_datums: read_date($scope.dto.sakuma_datums),
          beigu_datums: read_date($scope.dto.beigu_datums),
          atskaite_vidusposms_datums: read_date($scope.dto.atskaite_vidusposms_datums),
          atskaite_noslegums_datums: read_date($scope.dto.atskaite_noslegums_datums),
          var_eksportet_nzdis: $scope.dto.var_eksportet_nzdis,
        }

        Dialog.dialog("pages/pp/lzp.meta.form.html", p, opts, (p) => {
          const s = {
            ...p,
            sakuma_datums: write_date(p.sakuma_datums),
            beigu_datums: write_date(p.beigu_datums),
            atskaite_vidusposms_datums: write_date(p.atskaite_vidusposms_datums),
            atskaite_noslegums_datums: write_date(p.atskaite_noslegums_datums),
          }
          return Dialog.finish(new PpSaveLzpMeta(s), $scope.reload)
        })
      }

      this.fixupEkspertize = (ekspertize_id, old_versija_id, versija_id) => {
        if (!confirm("Vai ekspertīzei ir piesaistīta nepareizā versija, un šī ir pareizā?")) return
        const r = new EkspertizeFixup({
          id: ekspertize_id,
          old_versija_id,
          versija_id,
        })
        r.$save().then($scope.reload).catch($scope.failing)
      }

      this.createEkspertize = (ekspertizes_veids) => {
        const id = $scope.dto.id
        const r = new EkspertizeCreate({
          id,
          veids: ekspertizes_veids,
        })
        r.$create().then($scope.reload)
      }

      this.ekspertizu_veidi = Codifiers.kla.rev_ekspertizes
      this.kla = Codifiers.kla
      return this
    }
  )

  .controller("MPManagerBoxController", function (Dialog, $scope, Codifiers, MpChangeRawStatus) {
    this.mpChangeRawStatus = () => {
      const opts = {}
      const p = {
        id: $scope.dto.id,
        orig_statuss: $scope.dto.statuss,
        statuss: $scope.dto.statuss,
        _statusi: Codifiers.kla.statusi,
        _statuss: Codifiers.kla.statuss,
      }
      Dialog.dialog("pages/dialogs/pp-change-raw-status.form.html", p, opts, (p, action) => {
        if (action === "save") {
          return Dialog.finish(
            new MpChangeRawStatus({
              id: $scope.dto.id,
              statuss: p.statuss,
            }),
            $scope.reload
          )
        }
      })
    }
  })
